import * as React from 'react';
import {Col, Grid} from 'react-bootstrap';

export class Register extends React.Component {
	public state: any;

	constructor(props) {
		super(props);
		this.state = {user: '', pw: '', registered: false, failed: false, error: ''};

		this.handleChange = this.handleChange.bind(this);
		this.handlePwChange = this.handlePwChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	public handleChange(event) {
		this.setState({user: event.target.value});
	}

	public handlePwChange(event) {
		this.setState({pw: event.target.value});
	}

	public async handleSubmit(event) {
		event.preventDefault();
		const postData = {username: this.state.user, password: this.state.pw};
		console.log(postData);
		const rawResponse = await fetch('/api/register', {
			body: JSON.stringify(postData),
			credentials: 'include',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			method: 'POST'
		});
		const content = await rawResponse.json();

		console.log(content);
		if (content && content.success === false) {
			console.log('Failed to register');
			this.setState({failed: true, error: content.error})
		} else if (content && content.success === true) {
			console.log('Registered Successfully');
			this.setState({failed: false})
		}
		this.setState({registered: true});
	}

	public registerHelp(failed: boolean) {
		if (failed) {
			return (
				<Col md={6}>
					<p>Failed to register. You may already have an account. Please contact the administrator if you
						cannot remember your password.</p>
					<p>
						The error was: {this.state.error}
					</p>
				</Col>
			)
		}
		return (
			<Col md={6}>
				<h2 style={{color: '#ff0000'}}>Your Account Has Been Successfully Created.</h2>
				<p>Please put your email and password into the NFDN EDMC plugin, and restart EDMC.</p>
			</Col>
		)
	}

	public render() {
		return (
			<Grid>
				<Col md={6}>
					<form className="form-group" onSubmit={this.handleSubmit}>
						<label>
							Email:
						</label>
						<input className="form-control" name="username" type="text" value={this.state.username}
							   onChange={this.handleChange}/>
						<label>
							Password:
						</label>
						<input className="form-control" name="password" type="password" value={this.state.password}
							   onChange={this.handlePwChange}/>
						<input className="btn btn-default" type="submit" value="Submit"/>
					</form>
				</Col>
				{this.state.registered ? this.registerHelp(this.state.failed) : null}
			</Grid>
		);
	}

}



// WEBPACK FOOTER //
// ./src/Register.tsx